import React, { lazy, Suspense } from 'react'
import { Grid, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'

// import { TablaReportePorSilos } from '../../shared/TablaReportePorSilos/containers/TablaReportePorSilos'
import { GraficoSilos } from '../graficoSilos/containers/GraficoSilos'

const TablaEstadoElevador = lazy(() => import('../../shared/TablaEstadoElevador/containers/TablaEstadoElevador'))
const TablaReportePorSilosUno = lazy(() => import('../../shared/TablaReportePorSilos/containers/TablaReportePorSilosUno'))
const ReportePorSector = lazy(() => import('../../../ReportePorSector/containers/ReportePorSector'))
const ReportePorCereal = lazy(() => import('../../../ReportePorCereal/containers/ReportePorCereal'))

const ReportePorSectorYLinea = lazy(() => import('../../../ReportePorSectorYLinea/containers/ReportePorSectorYLinea'))
const ReportesTotales = lazy(() => import('../../../ReportesTotales/containers/ReportesTotales'))
const ReporteParaEmbarque = lazy(() => import('../../../Movimiento/reporteParaEmbarque/containers/ReporteParaEmbarque'))

const EspacioPorCerealDetalles = lazy(() => import('../../espacioPorCereal/containers/EspacioPorCerealDetalles'))
const DistribucionPorCereal = lazy(() => import('../../distribucionPorCereal/containers/DistribucionPorCereal'))
const DistribucionPorCondicionDetalles = lazy(() => import('../../distribucionPorCondicionDetalles/containers/DistribucionPorCondicionDetalles'))

const renderLoader = () => <div style={{ marginLeft: '10px', width: '20%' }}><CircularProgress style={{ color: '#3f51b5' }} /></div>
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}))

export const AbmMovimientosView = () => {
  const classes = useStyles()
  const [value, setValue] = React.useState('1')

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Grid container direction='row' justify='space-around' spacing={1} alignItems='center' style={{ marginTop: '-2%' }} >
      <div className={classes.root}>
        <TabContext value={value}>
          <AppBar position='static' color='default'>
            <TabList onChange={handleChange}
              aria-label='Control de Silos'
              indicatorColor='primary'
              textColor='primary'
              centered
            >
              <Tab label='Silos' value='1' />
              <Tab label='Estado Elevador' value='2' />
              <Tab label='Estado Silos' value='3' />
              <Tab label='Estado Sectores' value='4' />
              <Tab label='Estado Cereales' value='5' />
              <Tab label='Espacio Cereal-Sector' value='6' />
              <Tab label='Dist. por Cereal' value='7' />
              <Tab label='Dist. por Condición' value='8' />
              <Tab label='Rep. Embarque' value='9' />
              <Tab label='Rep. Sector y Línea' value='10' />
              <Tab label='Totales' value='11' />
            </TabList>
          </AppBar>
          <TabPanel value='1'>
            <Grid item xs={12}>
              <GraficoSilos />
            </Grid>
          </TabPanel>
          <TabPanel value='2'>
            <Grid xs={12} item>
              <Suspense fallback={renderLoader()}>
                <TablaEstadoElevador />
              </Suspense>  
            </Grid>
          </TabPanel>
          <TabPanel value='3'>
            <Grid item xs={12}>
              <Suspense fallback={renderLoader()}>
                <TablaReportePorSilosUno />
              </Suspense>  
              {/* <TablaReportePorSilos /> */}
            </Grid>
          </TabPanel>
          <TabPanel value='4'>
            <Grid item xs={12}>
              <Suspense fallback={renderLoader()}>
                <ReportePorSector />
              </Suspense>  
            </Grid>
          </TabPanel>
          <TabPanel value='5'>
            <Grid item xs={12}>
              <Suspense fallback={renderLoader()}>
                <ReportePorCereal />
              </Suspense>  
            </Grid>
          </TabPanel>
          <TabPanel value='6'>
            <Grid item xs={12}>
              <Suspense fallback={renderLoader()}>
                <EspacioPorCerealDetalles />
              </Suspense>  
            </Grid>
          </TabPanel>
          <TabPanel value='7'>
            <Grid item xs={12}>
              <Suspense fallback={renderLoader()}>
                <DistribucionPorCereal />
              </Suspense>  
            </Grid>
          </TabPanel>
          <TabPanel value='8'>
            <Grid item xs={12}>
              <Suspense fallback={renderLoader()}>
                <DistribucionPorCondicionDetalles />
              </Suspense>  
            </Grid>
          </TabPanel>
          <TabPanel value='9'>
            <Grid item xs={12}>
              <Suspense fallback={renderLoader()}>
                <ReporteParaEmbarque />
              </Suspense>  
            </Grid>
          </TabPanel>
          <TabPanel value='10'>
            <Grid item xs={12}>
              <Suspense fallback={renderLoader()}>
                <ReportePorSectorYLinea />
              </Suspense>
            </Grid>
          </TabPanel>
          <TabPanel value='11'>
            <Grid item xs={12}>
              <Suspense fallback={renderLoader()}>
                <ReportesTotales />
              </Suspense>  
            </Grid>
          </TabPanel>
          {/* <TabPanel value="10">
            <Grid xs={12} item>
              <SiloAVolcadora />
            </Grid>
          </TabPanel> */}
        </TabContext>
      </div>
    </Grid>
  )
}
